import styled from "styled-components";
import { theme } from "../../theme";
import { flexCenterCenter, transition02 } from "../../style/mixins";

interface BtnProps {
  type: "button" | "submit" | "reset";
  title: string;
  color: keyof (typeof theme)['color'] | keyof (typeof theme)['hoverColor'];
  size?: "sm" | "md" | "lg";
  fontSize?: "sm" | "md";
  onClick?: () => void;
}

interface BtnStyleProps {
  $color: keyof (typeof theme)['color'] | keyof (typeof theme)['hoverColor'];
  $size: "sm" | "md" | "lg";
  $fontSize?: "sm" | "md";
}

export default function Btn({ type, title, color, size = "md", fontSize = "md", onClick }: BtnProps) {
  return (
    <BtnStyle
      type={type}
      onClick={onClick}
      $color={color}
      $size={size}
      $fontSize={fontSize}
    >{title}</BtnStyle>
  );
}

export const BtnStyle = styled.button<BtnStyleProps>`
  color: #fff;
  font-size: ${({ $fontSize }) => $fontSize === "md" ? "0.875rem" : "0.6875rem" };
  font-weight: 600;
  line-height: 1;
  background-color: ${({ $color }) => theme.color[$color]};
  border: none;
  border-radius: 0.25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${transition02};

  ${({ $size }) => {
    switch ($size) {
      case "sm": {
        return `
          width: 1.875rem;
          height: 1.875rem;
          padding: 0;
        `;
      }
      case "md": {
        return `
          padding: 0.5rem 0.75rem;
        `;
      }
      case "lg": {
        return `
          min-width: 6.25rem;
          height: 2.25rem;
          padding: 0 0.75rem;
        `;
      }
    }
  }}

  &:hover {
    background-color: ${({ $color }) => theme.hoverColor[$color]};
  }
`;